import CurrentIBProgramsItem from './CurrentIBProgramsItem';

export default CurrentIBProgramsItem;
